module.exports = __webpack_public_path__ + "static/media/assets-management.574edda6.jpg";